import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import topback from "../images/beetitle.png";
import "./StudentMentalHealth.css";

const AboutCell = () => {
    return (
        <>
            <Header />

            <section class="content-section title-top" style={{ backgroundImage: `url(${topback})` }}>
                <div class="pattern-overlay">
                    <div class="container">
                        <div class="row">
                            <div className="col-lg-12 title-heading text-center mb-4">

                                <h2 className="page-title" style={{ marginBottom: '3rem' }}>
                                    Mental Health and Wellness Cell
                                </h2>

                                <h5 className="mt-3" style={{ color: '#fff' }}>
                                    SDWG Government College Beetan,
                                    District Una, Himachal Pradesh
                                </h5>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="container mt-3 mb-5" >


                <section>

                    <h3>About the Cell</h3>

                    <p>
                        SDWG Government College Beetan is committed to promoting the mental
                        health and overall well-being of its students, faculty and staff.
                        The College recognizes that emotional well-being is essential for
                        academic achievement, personal development and responsible
                        citizenship.
                    </p>

                    <p>
                        In line with the National Education Policy (NEP 2020), the National
                        Mental Health Programme (NMHP), Tele-MANAS initiative and the
                        directions issued by the Directorate of Higher Education,
                        Himachal Pradesh, the College has established a Mental Health and
                        Wellness Cell to create a safe, supportive and inclusive campus
                        environment.
                    </p>

                </section>

                {/* Vision */}

                <section>

                    <h3>Vision</h3>

                    <p>
                        To foster a healthy, inclusive and compassionate learning
                        environment where every student feels safe, valued and supported
                        in achieving emotional, psychological and academic well-being.
                    </p>

                </section>

                {/* Mission */}

                <section>

                    <h3>Mission</h3>

                    <ul>

                        <li>
                            To promote awareness regarding mental health and emotional
                            well-being.
                        </li>

                        <li>
                            To reduce stigma associated with mental health concerns.
                        </li>

                        <li>
                            To provide timely guidance, counselling and referral support.
                        </li>

                        <li>
                            To organize workshops, seminars and awareness programmes on
                            stress management, resilience and life skills.
                        </li>

                        <li>
                            To collaborate with the District Mental Health Programme (DMHP),
                            Tele-MANAS and other health agencies for counselling and outreach
                            activities.
                        </li>

                        <li>
                            To encourage positive mental health practices and peer support
                            among students.
                        </li>

                    </ul>

                </section>

                {/* Objectives */}

                <section>

                    <h3>Objectives</h3>

                    <ul>

                        <li>
                            Promote positive mental health among students and staff.
                        </li>

                        <li>
                            Identify students requiring psychological support at an early
                            stage.
                        </li>

                        <li>
                            Facilitate counselling and referral services through qualified
                            professionals whenever required.
                        </li>

                        <li>
                            Conduct orientation programmes on stress management,
                            examination anxiety, substance abuse prevention and suicide
                            prevention.
                        </li>

                        <li>
                            Maintain confidentiality and dignity of every individual
                            seeking support.
                        </li>

                        <li>
                            Strengthen collaboration with government health agencies and
                            mental health professionals.
                        </li>

                    </ul>

                </section>

                {/* Functions */}

                <section>

                    <h3>Functions of the Cell</h3>

                    <ul>

                        <li>
                            Organize Mental Health Awareness Programmes.
                        </li>

                        <li>
                            Celebrate World Mental Health Day and other relevant observances.
                        </li>

                        <li>
                            Arrange expert lectures, counselling sessions and interactive
                            workshops.
                        </li>

                        <li>
                            Disseminate information about available mental health services.
                        </li>

                        <li>
                            Coordinate with the District Mental Health Programme, Una,
                            for specialized counselling camps.
                        </li>

                        <li>
                            Display information regarding Tele-MANAS and other national
                            mental health helplines on the college notice boards and website.
                        </li>

                    </ul>

                </section>

                {/* Confidentiality */}

                <section>

                    <h3>Confidentiality</h3>

                    <p>
                        The Mental Health and Wellness Cell ensures that all discussions,
                        counselling interactions and referrals are treated with strict
                        confidentiality.
                    </p>

                    <p>
                        Information shared by students shall remain private except where
                        disclosure is necessary to protect the life or safety of the
                        student or others.
                    </p>

                </section>

                {/* Tele MANAS */}

                <section>

                    <h3>National Mental Health Support</h3>

                    <p>
                        Students may access the Government of India's Tele-MANAS services
                        for free mental health counselling.
                    </p>

                    <table className="table table-bordered">

                        <tbody>

                            <tr>

                                <th width="35%">Toll-Free Number</th>

                                <td>1800-89-14416</td>

                            </tr>

                            <tr>

                                <th>Short Code</th>

                                <td>14416 (Available 24×7)</td>

                            </tr>

                        </tbody>

                    </table>

                </section>

                {/* Committee */}

                <section>

                    <h3>Composition of the Cell</h3>

                    <table className="table table-bordered table-striped">

                        <thead className="table-light">

                            <tr>

                                <th width="8%">S. No.</th>

                                <th>Name</th>

                                <th>Designation in Cell</th>

                            </tr>

                        </thead>

                        <tbody>

                            <tr>
                                <td>1</td>
                                <td>Dr. Ritu Jaswal</td>
                                <td>Faculty Counselor</td>
                            </tr>

                            <tr>
                                <td>2</td>
                                <td>Dr. Gaurav Sharma</td>
                                <td>Convener (Anti-Ragging Cell)</td>
                            </tr>

                            <tr>
                                <td>3</td>
                                <td>Dr. Gurmel Singh</td>
                                <td>Member (Red Ribbon Club)</td>
                            </tr>

                            <tr>
                                <td>4</td>
                                <td>Prof. Richa Sharma</td>
                                <td>Member (Eco Club)</td>
                            </tr>

                            <tr>
                                <td>5</td>
                                <td>Prof. Gurjeet Kaur</td>
                                <td>Member (Women Cell)</td>
                            </tr>

                            <tr>
                                <td>6</td>
                                <td>Dr. Butta Ram</td>
                                <td>Member (Youth Red Cross)</td>
                            </tr>

                            <tr>
                                <td>7</td>
                                <td>Prof. Ramesh Kumar</td>
                                <td>Member (NCC)</td>
                            </tr>

                            <tr>
                                <td>8</td>
                                <td>Prof. Jyoti Sharma</td>
                                <td>Member (NSS)</td>
                            </tr>

                            <tr>
                                <td>9</td>
                                <td>Mr. Barinder Mohan Dhiman</td>
                                <td>Office Superintendent</td>
                            </tr>

                        </tbody>

                    </table>

                </section>

            </div>

            <Footer />
        </>
    );
};

export default AboutCell;